export default "__VITE_PUBLIC_ASSET__bdc542e9__"